import { cn } from '@shared/components/shadcn';
import { imagePathResolver, useClientConfig } from '@shared/utils';
import { ClassicGameCard } from '../../../../ClassicGameCard/ClassicGameCard';
import type { GameDetails } from '../../../../casino/types/types';
import type { MultiofferLandingPagePod } from '../../templates/MultiofferLandingPage/types.ts';

type GamePodsProps = {
  pods: Array<MultiofferLandingPagePod>;
  games: Array<GameDetails>;
  sectionClassName?: string;
};

function GamePods({ pods, games, sectionClassName }: GamePodsProps): React.JSX.Element | null {
  const { baseImgUrl } = useClientConfig();

  if (pods?.length === 0) {
    return null;
  }

  return (
    <section className={cn('flex flex-col gap-4', sectionClassName)} data-track-container="Grid" data-testid="game-pods">
      {pods.map((pod, index) => {
        const game = games.find(gameItem => gameItem.name.toLowerCase() === pod.gameId?.toLowerCase());

        if (!game) {
          return null;
        }

        return (
          <ClassicGameCard
            key={pod.gameId}
            variant="list"
            id={pod.gameId}
            href={pod.callToAction.link}
            gameName={game.displayName}
            backgroundImage={imagePathResolver(game.image ?? '', baseImgUrl, true)}
            playButtonText={pod.callToAction.text}
            playButtonVariant="primary"
            position={index + 1}
            showFavouriteButton={false}
            showInfoButton={false}
            className="w-full h-auto"
            playButtonTrackName="Select"
          />
        );
      })}
    </section>
  );
}

export { GamePods, type GamePodsProps };
